/*
 * Main entry point
 * esbuild bundles this into library/js/dist/scripts.js
 * jQuery is provided by WordPress (external)
 */

// Vendor
import './vendor/slick.min.js';

// App
import './app.core.js';
